import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/aroma1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/aroma3.png'
import srj4 from '../../images/aroma4.png'
import srj5 from '../../images/aroma5.png'
import srj6 from '../../images/aroma6.png'
import srj7 from '../../images/aroma7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/aroma10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const AromaMonk = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Global Expansion & <br/> Growth for Aroma Monk</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>30+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>India</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Essential Oils & Perfume Manufacturer</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Rajat is the Sales Head of Aroma Monk, one of <br/> India’s leading manufacturers of fragrances, <br/> essential oils, perfumes, and attars. With a strong <br/> domestic presence, Aroma Monk wanted to <br/> expand internationally and recently launched a <br/> new Private Label Manufacturing vertical catering <br/> to B2B buyers worldwide.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>Although Aroma Monk had a solid business foundation in India, the company faced challenges in scaling globally:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Previous 2–3 SEO agencies failed to deliver tangible results.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>No visibility for export-focused keywords targeting Europe and the Gulf.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>The newly launched Private Label Manufacturing vertical had little to no online authority.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>SERP rankings were weak, limiting international visibility.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>No presence in AI-driven platforms (Google SGE, Bing AI, Perplexity) where global buyers now search.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>The client didn’t just want traffic—they needed qualified B2B leads from international buyers.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Rajat explained his priority: build global authority and scale the Private Label Manufacturing vertical. Past agencies delivered traffic but not leads, so he wanted AI-focused SEO and a clear export keyword strategy for Europe and Gulf markets.</p>
                                
                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Identify how to rank in Google SERPs and appear in AI search engines.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Provide a keyword strategy focused on exports and B2B leads.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Build authority for the Private Label Manufacturing vertical.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Create a detailed roadmap to generate international leads from Europe and Gulf countries.</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-6">
                                    <img src={srj4} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-6">
                                    <img src={srj5} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-6">
                                    <img src={srj6} alt="srj3" className='img-fluid' />
                                </div>
                                
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <p className='heading_description text-dark mb-0'>Although Aroma Monk already has a good reputation in India but when we think of the global and export market, then for the market, Aroma Monk is a new brand. There are the following challenges that we have seen:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Highly competitive global market with strong European and Middle Eastern players.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Keyword overlap between retail terms (targeting individuals) and B2B export terms (targeting businesses).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>New vertical (Private Label Manufacturing) lacked search authority and content.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Missing presence in AI search engines, where buyers increasingly look for suppliers.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Need to balance domestic visibility with global expansion priorities.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p>Full technical SEO audit: crawl depth, indexation, canonical issues, thin/duplicate content. And an Export-focused keyword audit to separate B2B vs retail intent keywords.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content & Export Authority Strategy</div>
                                                <p>
                                                    <ul>
                                                        <li>Built a pillar-cluster model for the website content</li>
                                                        <li>Added export market pages with localized content and hreflang tags. And published in-depth case studies and certifications (Halal, GMP, ISO, IFRA compliance) for buyer trust.</li>
                                                    </ul>
                                                </p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI SEO (Answer Engine Optimization & Generative Engine Optimization)</div>
                                                <p>Optimized FAQs and structured Q&A content for queries and added schema markup (Product, Organization, FAQ, Review) to improve AI parsing.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Backlink & PR Strategy</div>
                                                <p>Built authority links from fragrance industry publications, trade portals, and export associations. Did PR campaigns highlighting Aroma Monk’s private label capability and certifications.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Paid Ads</div>
                                                <p>Google Ads targeting for the export leads and LinkedIn Ads to reach procurement managers in the cosmetics, wellness, and fragrance industries.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Email Marketing</div>
                                                <p>We have launched many email marketing campaigns, which helped in connecting with potential buyers and helped us in reducing the Customer Acquisition Cost (CAC).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics & Ops</div>
                                                <p>We made sure we track everything so that we can avoid the guesswork. For this, we were tracking website UX and user journey, website engagement using heatmaps, Google SERP keyword tracking, and AI Brand mention tracking, etc.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<><b>Want to expand your manufacturing business <br/> globally?</b></>} title2={<>Let us build your AI SEO and export-focused strategy.</>} />
                    
                    <section className="intro_about_section section_space project_outcome max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Growth on Newly Launched Vertical</div>
                                                <p>Ranking growth for private label perfume/attars/essential oils keywords.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Increased Organic Visibility</div>
                                                <p>Increased visibility in Google SERPs and AI search engines for export queries.</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Qualified Leads Flow</div>
                                                <p>First wave of qualified export leads from the UAE and Saudi Arabia.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Good Backlink Network Graph</div>
                                                <p>Improved authority with high-quality backlinks and industry-specific PR.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Continuous Export Leads</div>
                                                <p>Steady pipeline of enquiries from Europe and the Gulf regions.</p>
                                            </div>
                                        </li>



                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default AromaMonk;
